import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/sagas/averageNumberOfClientsPerClassSagas";
import PropTypes from "prop-types";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
// import CompareDates from "./smartComponents/compareDates";
// import CompareType from "./smartComponents/compareType";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
// import VcCompare from "../../../../components/vcCompare/vcCompare";

import "../attendance_common.css.scss";

const AverageNumberOfClientsPerClassModule = (props) => {
  const {
    filtersDirty,
    isLoading,
    updatesLoading,
    // selectedFilters: { compare: compareDates },
    selectedRequestDates: { startDate, endDate },
    // filters: { toggles },
    currentUser: { clientName = "" }
  } = useSelector((state) => state.averageNumberOfClientsPerClassReducer);

  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props.params));
  }, []);

  const renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className="select-box-no-width"></div>
            {/*{toggles && toggles.compareDates && toggles.compareDates.label && (*/}
            {/*  <div className="select-box-no-width">*/}
            {/*    <p>{toggles.compareDates.label}</p>*/}
            {/*    <CompareDates />*/}
            {/*  </div>*/}
            {/*)}*/}

            <div className="top-filter__right">
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box monthly">
                <p>Date</p>
                <DatePicker />
              </div>
              {/*{compareDates && (*/}
              {/*  <>*/}
              {/*    <div className="vc-compare">*/}
              {/*      <VcCompare />*/}
              {/*    </div>*/}
              {/*    <div className="select-box-no-width compare-period-select-box">*/}
              {/*      <p>Compare Period</p>*/}
              {/*      <CompareType />*/}
              {/*    </div>*/}
              {/*  </>*/}
              {/*)}*/}
              {renderUpdateBtn()}
              {renderResetBtn()}
            </div>
          </div>
        </div>
        <div className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <TableOrStackedBarChart />
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="attendance-root">
      <SectionToggle
        autoHeight
        paddingBottom={0}
        height={690}
        title={`Average Number of ${clientName} Per Class`}
        isLoading={isLoading}
        content={content()}
      />
    </div>
  );
};
export default AverageNumberOfClientsPerClassModule;

AverageNumberOfClientsPerClassModule.propTypes = {
  params: PropTypes.object
};
